import { size } from 'lodash';

export default {
    buttons: {
        start: 'Start',
        end: 'End Activity',
        submit: 'Submit',
        next: 'Next Question',
        result: 'View Results',
        nextModule: 'Next',
        selfDone: 'Self-study Complete',
        taskDone: 'Assignment Complete',
        moduleStart: 'Start Activity',
    },
    teacher: {
        setting: 'Activity Settings',
        wayOfProgress: 'Progression Method',
        wayOfReading: 'Reading Method',
        title: 'Activity Title',
        guide: 'Activity Guide',
        tooltip: `
        <span class="tooltip_list">
            <strong>With Teacher</strong>
            <span>Go through one question at a time with the Teacher</span>
         </span>
         <span class="tooltip_list">
            <strong>Self-paced</strong>
            <span>Students solve all questions at their own pace</span>
        </span>
        `,
        screen: 'Activity Screen',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `Activity Content <span>${title}</span>`;
            }
            return 'Activity Content';
        },
        summary: 'Activity Summary',
        addQuestions: {
            search: {
                empty: '✨ Search for words in the box above to see results here.\nPaste sheet data into the search box to send rows\ndirectly to the pending list below.',
                placeholder: 'Search a word, or paste from Excel / Google Sheets',
            },
            wait: {
                empty: {
                    default: 'Pending words will be added together when you tap [Add to Activity].',
                    choice: 'Pending words will be added together when you tap [Add to Activity].\nLeave wrong choices empty to auto-fill them from other words at register time.\nSheet columns are accepted in order: word / meaning / wrong 1 / wrong 2 / wrong 3.',
                },
            },
            infoTitle: 'Search for words to add your own questions.',
            infoDesc: {
                default: 'Paste from Excel or Google Sheets to add multiple at once!',
                choice: 'Paste from Excel or Google Sheets to add multiple at once,\nand empty wrong choices will be auto-filled!',
            },
            noMeaning: {
                title: 'Some words have no meaning!',
                message: 'Some words have no meaning.<br />Add only the rest, excluding these words?',
                enterMeaning: 'Enter meaning',
                submitRest: 'Add the rest',
            },
            invalidChar: {
                title: 'Invalid characters found!',
                message: 'Meanings can only contain Korean, English letters, numbers, and certain symbols.',
                invalidCharsLabel: 'Invalid characters in input:',
            },
            registerResult: 'Registration Result',
        },
    },
    alert: {
        wrong: "Oops, that's incorrect. Please try again.",
        chancesExhausted: "Oops, that's incorrect! Check the answer.",
        waiting: () => {
            const messages = [
                'All done! Please wait a moment.',
                'Great! Please wait a moment.',
                'Good job! Please wait a moment.',
            ];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: 'Question',
    answerRate: 'Accuracy',
    relation: '{relation} Relationship',
    allDone: 'All questions have been completed. Please end the Activity!',
    champion: 'Champion',
    allSelect: 'Select All',
    majorVocabulary: 'Major Vocabulary',
    remainingVocabulary: 'Remaining Vocabulary',
    students: {
        errorTooltip: 'Student is offline',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `Student ${isOngoing ? 'Status' : 'Results'}`;
            },
        },
        standby: 'Not Started',
        notAttended: 'Not Participated',
        inProgress: 'In Progress',
        notCompleted: 'Incomplete',
        completed: 'Completed',
    },
    modal: {
        title: 'End Activity',
        message: 'Would you like to end the Activity?',
    },
    state: {
        correct: 'Correct',
        wrong: 'Incorrect',
    },
    toast: {
        addStarStudent: 'Gave a Praise Star to {name}',
        addAllStar: 'Gave Praise Stars to all students ({length})',
        failedStar: 'Failed to give a Praise Star',
        undo: 'Undo',
        undoFailed: 'Failed to undo Praise Stars',
    },
};
